<script>
import { Line, mixins } from 'vue-chartjs';


export default {
    extends: Line,
    mixins: [mixins.reactiveProp],
    props: ['chartData', 'options'],
    mounted () {
        const options = Object.assign({
            responsive: true,
            maintainAspectRatio: true,
        }, this.options);

        this.renderChart(this.chartData, options);
    }
}
</script>
